export default __webpack_public_path__ + "static/media/reboot.8130c4bb.svg";